export default __webpack_public_path__ + "static/media/04.275e40dd.jpg";